<template>
  <div id="messages">
    <b-card overlay :img-src="gif" class="text-center" img-height="350px">
      <span class="card-header text-center">
        <strong>Messages</strong>
      </span>
      <div
        v-if="count < target"
        @mouseover="
          sendEvent('messages', 'hover', 'messages-gauge-interaction')
        "
      >
        <br />
        <gauge
          title="Messages"
          :current="count"
          :target="target"
          :colour="gaugeColour"
        ></gauge>
      </div>
      <div v-else>
        <b-card-img :src="trophy"></b-card-img>
        <b-list-group flush>
          <b-list-group-item>
            <strong>Target:</strong>
            {{ target.toLocaleString() }}
          </b-list-group-item>
          <b-list-group-item>
            <strong>Current:</strong>
            {{ count.toLocaleString() }}
          </b-list-group-item>
        </b-list-group>
      </div>

      <b-list-group flush>
        <b-list-group-item>
          <b-container class="text-center">
            <transition name="slide-fade">
              <div v-if="!displayRecentDonator">
                <strong>Send a message!</strong>
              </div>

              <div v-else-if="displayRecentDonator">
                <strong>Last Message By:</strong>
                {{ msgByUsername }}
              </div>
            </transition>
          </b-container>
        </b-list-group-item>

        <b-list-group-item>
          <div :style="style">
            <b-container v-if="this.state == 'released'" class="text-center">
              |
              <b-button
                @mouseover="displayBalance()"
                @click="
                  purchase('Message-100');
                  sendEvent('messages', 'click', 'message-100-btn');
                "
                >Send Message</b-button
              >|
              <b-button
                @mouseover="displayBalance()"
                @click="
                  purchase('Message-500');
                  sendEvent('messages', 'click', 'message-500-btn');
                "
                >Send Global Message</b-button
              >
            </b-container>
            <b-container v-else class="text-center">
              |
              <b-button
                @mouseover="displayBalance()"
                @click="
                  purchase('Message-1');
                  sendEvent('messages', 'click', 'message-1-btn');
                "
                >Send Message</b-button
              >
              |
            </b-container>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-card>

    <b-modal
      scrollable
      size="xl"
      id="txmodal"
      ref="txmodal"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header-close
      title="Thank you!"
    >
      <div class="d-block text-center">
        <b-list-group flush>
          <b-list-group-item>
            Please choose a message!
            <template v-if="donatorMessage.broadcastType == 'broadcast'">
              <br />-
              <span style="color: green">Visible to this channel only</span>
            </template>

            <template v-else-if="donatorMessage.broadcastType == 'global'">
              <br />-
              <span style="color: green">Visible to ALL channels</span>
            </template>
          </b-list-group-item>

          <b-list-group-item>
            <b-input-group prepend="Message">
              <b-form-select
                :state="donatorMsgMessageValidation"
                v-model="donatorMessage.message"
                class="mb-3"
                :disabled="donatorMessage.sent"
              >
                <option :value="null">Select</option>
                <optgroup label="Age of Empires">
                  <option value="Wololo!">Wololo!</option>
                </optgroup>
                <optgroup label="Borderlands">
                  <option value="Heyooooo!">Heyooooo!</option>
                  <option value="I'M DEAD I'M DEAD OHMYGOD I'M DEAD!!">
                    I'M DEAD I'M DEAD OHMYGOD I'M DEAD!!
                  </option>
                </optgroup>
                <optgroup label="Fallout">
                  <option value="War, war never changes!">
                    War, war never changes!
                  </option>
                  <option value="Hey everybody, this is Three Dog">
                    Hey everybody, this is Three Dog!
                  </option>
                </optgroup>
                <optgroup label="GTA">
                  <option value="Hey cousin! lets go bowling!">
                    Hey cousin! lets go bowling!
                  </option>
                  <option value="All we had to do was follow the damn train!">
                    All we had to do was follow the damn train!
                  </option>
                </optgroup>
                <optgroup label="Mortal Kombat">
                  <option value="Get over here!">Get over here!</option>
                </optgroup>
                <optgroup label="Portal">
                  <option value="The cake is a lie!">The cake is a lie!</option>
                </optgroup>
                <optgroup label="Skryim">
                  <option value="I took an arrow to the knee!">
                    I took an arrow to the knee!
                  </option>
                  <option value="I have wares, if you have the coin!">
                    I have wares, if you have the coin!
                  </option>
                </optgroup>
                <optgroup label="WoW">
                  <option value="For the Horde!">For the Horde!</option>
                  <option value="For the Alliance!">For the Alliance!</option>
                  <option value="Lok'tar ogar!">Lok'tar ogar!</option>
                  <option value="Zug Zug!">Zug Zug!</option>
                  <option value="Taz'dingooo!">Taz'dingooo!</option>
                  <option value="Victory for Sylvanas!">
                    Victory for Sylvanas!
                  </option>
                  <option value="Aah..I've been expecting you.">
                    Aah..I've been expecting you!
                  </option>
                  <option value="Glory to the Sin'dorei!">
                    Glory to the Sin'dorei!
                  </option>
                  <option value="Leeroy jenkinssssss!">
                    Leeroy jenkinssssss!
                  </option>
                  <option value="Thrall is green Jesus!">
                    Thrall is green Jesus!
                  </option>
                </optgroup>
                <optgroup label="Misc">
                  <option value="All your base are belong to us!">
                    All your base are belong to us!
                  </option>
                  <option value="Cover me, i'm reloading!">
                    Cover me, i'm reloading!
                  </option>
                  <option value="Reloading!">Reloading!</option>
                  <option value="Grenade!">Grenade!</option>
                  <option value="Hold your fire!">Hold your fire!</option>
                  <option value="HADOUKEN!">HADOUKEN!</option>
                </optgroup>
              </b-form-select>
            </b-input-group>
          </b-list-group-item>
        </b-list-group>

        <div v-if="donatorMessage.sending == true">
          <b-spinner variant="primary" label="Text Centered" />
        </div>

        <div
          v-else-if="
            donatorMessage.error == true && donatorMessage.sending == false
          "
        >
          <b-alert
            variant="danger"
            show
            dismissible
            fade
            @dismissed="
              donatorMessage.error = false;
              donatorMessage.errorMsg = '';
              sendEvent('messages', 'click', 'donator-msg-error-dismiss');
            "
            >{{ donatorMessage.errorMsg }}</b-alert
          >
        </div>

        <div
          v-else-if="
            donatorMessage.error == false &&
            donatorMessage.sending == false &&
            donatorMessage.sent == true
          "
        >
          <b-alert
            variant="success"
            show
            dismissible
            fade
            @dismissed="
              sendEvent('messages', 'click', 'donator-msg-success-dismiss')
            "
            >Message sent!</b-alert
          >
        </div>

        <div>
          <template v-if="donatorMessage.sent == false">
            <b-button
              class="mt-3"
              variant="outline-success"
              block
              :disabled="donatorMessage.sending"
              @click="
                sendDonatorMsg();
                sendEvent('messages', 'click', 'donator-msg-btn-send');
              "
              >Send!</b-button
            >
          </template>

          <template v-else-if="donatorMessage.sent == true">
            <b-button
              class="mt-3"
              variant="danger"
              block
              :disabled="donatorMessage.sending"
              @click="
                $bvModal.hide('txmodal');
                sendEvent('messages', 'click', 'donator-msg-btn-close');
              "
              >Close!</b-button
            >
          </template>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Gauge from "@/components/utils/Gauge.vue";
import BitsAPI from "@/api/bits.js";
import MessagesAPI from "@/api/messages.js";
import NotificationsAPI from "@/api/notifications.js";
import ConfigAPI from "@/api/config.js";
import hearts from "@/assets/hearts.gif";
import stars from "@/assets/stars.gif";
import trophy from "@/assets/trophy.gif";
import { setInterval, setTimeout } from "timers";

export default {
  name: "mesages",
  data() {
    return {
      state: "",
      // images
      gif: "",
      gifOne: stars,
      gifTwo: hearts,
      trophy: trophy,

      count: 1,
      target: 0,

      displayRecentDonator: false,
      messageTs: "",
      msgByUsername: "",

      channelName: "",

      //theme settings
      ButtonTxtColour: "#FFFFFF",
      ButtonBkgColour: "#5583c7",
      gaugeColour: "#5583c7",

      // donator custom notification
      donatorMessage: {
        author: "",
        message: null,
        broadcastType: "",
        sending: false,
        sent: false,
        delay: 10000,
        error: false,
        errorMsg: "",
        bitsTxId: "",
      },
    };
  },
  mounted() {
    this.setConfig();
    this.getMessages();

    this.channelName = ConfigAPI.getUsername();

    this.eventBus.$on("new-donator-msg", this.newDonation);

    this.eventBus.$on("messages-update", this.msgsUpdated);

    this.eventBus.$on("bits-tx-completed", this.txComplete);

    this.eventBus.$on("custom-notification", this.newNotification);

    setInterval(this.displayRecentDonation.bind(this), 15000);

    this.state = this.$store.getters.getReleasedState();
  },
  activated: function () {
    ga("set", "page", "/messages");
    ga("send", "pageview");
  },
  methods: {
    setConfig: function () {
      var globalConfig = ConfigAPI.getGlobalConfig();

      if (globalConfig.images) {
        var images = globalConfig.images;
        if (images.one) {
          this.gifOne = images.one;
        }
        if (images.two) {
          this.gifTwo = images.two;
        }
      }

      var config = ConfigAPI.getBroadcasterConfig();
      if (config.messages) {
        var messages = config.messages;
        if (messages.gauge_colour) {
          this.gaugeColour = messages.gauge_colour;
        }
        if (messages.target) {
          this.target = messages.target;
        }
      }

      if (config.panel_settings) {
        var panel = config.panel_settings;
        if (panel.font_colour) {
          this.ButtonTxtColour = panel.font_colour;
        }
        if (panel.background_colour) {
          this.ButtonBkgColour = panel.background_colour;
        }
      }
      return;
    },

    getMessages: function () {
      MessagesAPI.getMessages()
        .then((resp) => {
          this.count = resp.data.count;
          if (resp.data.last_message) {
            this.messageTs = resp.data.last_message;
          }

          if (resp.data.donator) {
            this.msgByUsername = resp.data.author;
          }
        })
        .catch((error) => {
          this.sendEvent("api", "failure", "get-Messages");
        });
    },
    getProucts: function () {
      BitsAPI.getProducts();
    },
    purchase: function (sku) {
      BitsAPI.purchase(sku);
    },
    displayBalance: function () {
      BitsAPI.showBalance();
    },
    newDonation: function (tx) {
      if (tx.displayName) {
        this.msgByUsername = tx.displayName;
      }
      if (tx.product_data) {
        var product = tx.product_data;
        if (product.cost) {
          this.count += 1;
        }
      }
      if (tx.timestamp) {
        this.messageTs = tx.timestamp;
      }

      this.gif = this.gifOne;
      setTimeout(
        function () {
          this.gif = this.gifTwo;
        }.bind(this),
        60000
      );

      setTimeout(
        function () {
          this.gif = "";
        }.bind(this),
        120000
      );
    },
    txComplete: function (tx) {
      if (tx.initiator != "current_user") {
        return;
      }
      this.sendEvent("messages", "processed", "bits-tx-complete");

      // set donator
      this.donatorMessage.title = "Message!";
      this.donatorMessage.message = null;
      this.donatorMessage.sent = false;
      this.donatorMessage.author = tx.displayName;
      this.donatorMessage.bitsTxId = tx.transactionId;
      this.donatorMessage.broadcastType = "broadcast";
      this.donatorMessage.delay = 90000;

      // publication choice
      switch (true) {
        case tx.product.sku == "Message-1":
        case tx.product.sku == "Message-100":
          break;
        case tx.product.sku == "Message-500":
          this.donatorMessage.broadcastType = "global";
          break;
        default:
          return;
      }

      this.$bvModal.show("txmodal");
    },
    msgsUpdated: function (messages) {
      this.count = messages.count;
      if (messages.last_transaction) {
        this.messageTs = messages.last_message;
      }
      if (messages.author) {
        this.msgByUsername = messages.author;
      }
    },
    sendDonatorMsg() {
      this.donatorMessage.error = false;
      this.donatorMessage.errorMsg = "";
      this.donatorMessage.sending = true;
      this.count++;
      switch (true) {
        case !this.donatorMsgMessageValidation:
          this.donatorMessage.error = true;
          this.donatorMessage.errorMsg =
            "Oops! You have incorrectly set your Message!";
          this.donatorMessage.sending = false;
          this.$refs.donatorMessageMsg.$el.focus();
          this.sendEvent(
            "messages",
            "failure",
            "invalid-donator-form-input-message"
          );
          return;
      }

      var message = {
        title: this.donatorMessage.title,
        message: this.donatorMessage.message,
        author: this.donatorMessage.author,
        broadcast_type: this.donatorMessage.broadcastType,
        delay: 15000,
        bits_tx_id: this.donatorMessage.bitsTxId,
      };

      NotificationsAPI.sendMessage(message)
        .then((resp) => {
          var data = resp.data;

          if (data.error) {
            this.donatorMessage.error = true;
            this.donatorMessage.errorMsg =
              data.error + " expiration:" + data.expiration;
            this.donatorMessage.sending = false;
            this.sendEvent("messages", "send", "donator-send-message-exceeded");
            return;
          }

          this.donatorMessage.sending = false;
          this.donatorMessage.sent = true;
          this.sendEvent("messages", "send", "donator-send-message-success");
        })
        .catch((error) => {
          this.sendEvent("api", "failure", "donator-message-send-failure");
          this.donatorMessage.sending = false;
          this.donatorMessage.error = true;
          this.donatorMessage.errorMsg =
            "oops! there was an error on the server :'(";
        });
    },
    displayRecentDonation: function () {
      if (this.msgByUsername == "") {
        return (this.displayRecentDonator = false);
      }
      this.displayRecentDonator = !this.displayRecentDonator;
    },
    newNotification: function (notification) {
      if (notification.author != this.donatorMessage.author) {
        return;
      }
      if (notification.bits_tx_id) {
        if (notification.bits_tx_id != this.donatorMessage.bitsTxId) {
          return;
        }
      }

      this.donatorMessage.sent = true;
    },
  },
  computed: {
    style() {
      return {
        "--btnBkgColour": this.ButtonBkgColour,
        "--btnFontColour": this.ButtonTxtColour,
      };
    },
    donatorMsgMessageValidation() {
      return this.donatorMessage.message != null;
    },
  },
  components: {
    Gauge,
  },
};
</script>

<style scoped>
.btn-secondary {
  background-color: var(--btnBkgColour);
  color: var(--btnFontColour);
}

.card {
  border-color: var(--btnBkgColour);
  border-style: none;
}

.card-header {
  background-color: var(--btnBkgColour);
  color: var(--btnFontColour);
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>

<style>
.popover {
  max-width: none;
}
</style>
